import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { DOMAIN_URL, GET_DOMAINS_RENEW } from './endpoints'
import {
  DomainRenewPayload,
  CreatePrivateNameserverPayload,
  DeleteDNSRecordPayload,
  DeletePrivateNameserverPayload,
  EditDNSRecordPayload,
  UpdateNameServersPayload,
  UpdatePrivateNameserverPayloadIP,
  CreateDNSRecordPayload,
  UpdateAdditionalFieldsPayload,
  RetryRegistrationPayload,
} from '@/modules/domainManagement/types/api/DomainManagementPayloads'
import { ContactInfo } from '@/modules/domainManagement/types/api/DomainManagementClientInfoResponse'
import AxiosFactory from '@/entities/security/AxiosFactory'
export default class DomainManagementApi {
  async toggleRegisterStatus(req: { domainid: number; lockstatus: boolean }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(`${DOMAIN_URL}${req.domainid}/registar-lock`, {
        lockstatus: req.lockstatus,
      })
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getLockStatus(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/registar-lock`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getEPPCode(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/epp-code`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getNameServers(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/nameservers`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getPrivateNameServers(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/private-nameservers`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async updateNameServers(req: { domainid: number; filteredNameservers: UpdateNameServersPayload }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(
        `${DOMAIN_URL}${req.domainid}/nameservers`,
        req.filteredNameservers,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getDomain(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getAutorenewStatus(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/autorenew`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async toggleAutorenewStatus(req: { domainId: number; autorenew: boolean }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(`${DOMAIN_URL}${req.domainId}/autorenew`, {
        autorenew: req.autorenew,
      })
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async resendVerificationEmail(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(
        `${DOMAIN_URL}${domainid}/resend-irtp-verification-email`,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getOwnerChange(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}${domainid}/owner-change`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async resendOwnerChangeEmail(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(
        `${DOMAIN_URL}${domainid}/owner-change/resend-email`,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async cancelOwnerChange(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().delete(`${DOMAIN_URL}${domainid}/owner-change`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getDomainRenewPrices(req: DomainRenewPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(
        `${GET_DOMAINS_RENEW}/${req.domainId}/${req.domainName}`,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getClientInfo(domainid: number) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(`${DOMAIN_URL}/${domainid}/client-details`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async saveContactInfo(req: { domainid: number; contactDetails: ContactInfo; changedFields: string[] }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(`${DOMAIN_URL}${req.domainid}/client-details`, {
        contactDetails: req.contactDetails,
        changedFields: req.changedFields,
      })
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async updateAdditionalFields(payload: UpdateAdditionalFieldsPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(
        `${DOMAIN_URL}${payload.domainId}/additional-fields`,
        { fields: payload.fields },
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async retryRegistration(payload: RetryRegistrationPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(
        `${DOMAIN_URL}${payload.domainId}/retry-registration`,
        { fields: payload.fields },
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async createPrivateNameServer(payload: CreatePrivateNameserverPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(
        `${DOMAIN_URL}/${payload.domainId}/private-nameservers`,
        {
          ns: payload.ns,
          ipaddress: payload.ipaddress,
        },
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async updatePrivateNameServerIP(payload: UpdatePrivateNameserverPayloadIP) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(
        `${DOMAIN_URL}/${payload.domainId}/private-nameservers`,
        {
          ns: payload.ns,
          currentipaddress: payload.currentipaddress,
          newipaddress: payload.newipaddress,
        },
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async deletePrivateNameServer(payload: DeletePrivateNameserverPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().delete(
        `${DOMAIN_URL}${payload.domainId}/private-nameservers`,
        {
          data: {
            ns: payload.ns,
          },
        },
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async getDNSRecords(payload: { domainId: number; domainName: string }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(
        `${DOMAIN_URL}${payload.domainId}/dns-manager/record?zoneName=${payload.domainName}`,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async deleteDNSRecord(payload: DeleteDNSRecordPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(
        `${DOMAIN_URL}${payload.domainId}/dns-manager/record`,
        payload,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async editDNSRecord(payload: EditDNSRecordPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(
        `${DOMAIN_URL}${payload.domainId}/dns-manager/record`,
        payload,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async createDNSRecord(payload: CreateDNSRecordPayload) {
    try {
      const response = await AxiosFactory.createAxiosInstance().patch(
        `${DOMAIN_URL}${payload.domainId}/dns-manager/record`,
        payload,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async checkTransferLockSupport(tld: string) {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(
        `${DOMAIN_URL}check-tld-transfer-lock-support?tld=${tld}`,
      )
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
